import React from "react";

const PaperclipSVG = (props) => {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1258_510)">
                <path d="M26.5 16V26.5C26.5 28.71 24.71 30.5 22.5 30.5C20.29 30.5 18.5 28.71 18.5 26.5V16C18.5 14.62 19.62 13.5 21 13.5C22.38 13.5 23.5 14.62 23.5 16V25.5C23.5 26.05 23.05 26.5 22.5 26.5C21.95 26.5 21.5 26.05 21.5 25.5V16H20V25.5C20 26.88 21.12 28 22.5 28C23.88 28 25 26.88 25 25.5V16C25 13.79 23.21 12 21 12C18.79 12 17 13.79 17 16V26.5C17 29.54 19.46 32 22.5 32C25.54 32 28 29.54 28 26.5V16H26.5Z" fill="black"/>
            </g>
            <defs>
                <clipPath id="clip0_1258_510">
                    <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 -1 34 34)"/>
                </clipPath>
            </defs>
        </svg>

    );
};

export default PaperclipSVG;
